export enum FeatureFlag {
  NewLayout = "newlayout",
  DisplayGovernance = "displayGovernance",
}

export type FeatureFlags = {
  [FeatureFlag.NewLayout]?: boolean
  [FeatureFlag.DisplayGovernance]?: boolean
}
